// material-ui
import { useTheme } from '@mui/material/styles';
import { useDispatch } from 'react-redux';
import { activeItem } from '../../../store/slices/menuSlice';
// ==============================|| LOGO SVG ||============================== //

const Logo = ({ short = false }) => {
    const theme = useTheme();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(activeItem(['accueil']));
        window.location.href = process.env.PUBLIC_URL;
    };

    return (
        <img
            src={`${process.env.PUBLIC_URL}/assets/img/${theme.palette.mode === 'dark' ? (short ? 'logo-dark-mode-short.png' : 'logo-dark-mode.svg') : (short ? 'logo-short.png' : 'logo.svg')}`}
            alt="Uniprevoyance"
            width={ short ? "53" : "166"}
            height="61"
            onClick={handleClick}
            style={{cursor: 'pointer'}}
        />
    );
};

export default Logo;
